import { Dispatch, SetStateAction, useEffect, useState } from "react";
import SpecialistApi from "../../../../../api/specialistsApi";
import MultipleSelect from "../../../../../components/MultipleSelect/MultipleSelect";
import StandartButton from "../../../../../components/StandartButton/StandartButton";
import { directions } from "../../../../../constans/directions";
import { ISO639Lang } from "../../../../../constans/languagesList";
import {
  NewDiscountPromocode,
  TreeQuizChoosedSpecialistType,
} from "../../../../../types/Promocodes";
import {
  MainSpecializations,
  SpecialistLevel,
  SpecialistTag,
} from "../../../../../types/TypeSpecialist";
import { getTranslation } from "../../../../../utils/getTranslation";
import { SelectFieldsPromocodeData } from "../CreatePromocode";
import s from "./PromocodeSelection.module.css";

type PromocodeSelectionProps = {
  selectFieldsData: SelectFieldsPromocodeData;
  promocodeData: NewDiscountPromocode;
  setSelectFieldsData: Dispatch<SetStateAction<SelectFieldsPromocodeData>>;
  setPromocodeData: Dispatch<SetStateAction<NewDiscountPromocode>>;
  defaultSelectionData?: {
    language: string;
    mainSpecialization: MainSpecializations;
    direction: TreeQuizChoosedSpecialistType;
    level: SpecialistLevel;
    topic: SpecialistTag;
  }[];
};

type DropDownMenuData = { lable: string; value: string };
const PromocodeSelection = ({
  selectFieldsData,
  setSelectFieldsData,
  promocodeData,
  setPromocodeData,
  defaultSelectionData,
}: PromocodeSelectionProps) => {
  const token = localStorage.getItem("token");
  const lodash = require("lodash");
  const [selectionCombinations, setSelectionCombinations] = useState<
    {
      language: string;
      mainSpecialization: DropDownMenuData;
      direction: TreeQuizChoosedSpecialistType;
      level: DropDownMenuData;
      topic: DropDownMenuData;
    }[]
  >([]);
  const [newSelectionCombination, setNewSelectionCombination] = useState<{
    language: string;
    mainSpecialization: string;
    direction: TreeQuizChoosedSpecialistType;
    level: string;
    topic: string;
  }>({
    language: "",
    mainSpecialization: "",
    direction: "" as TreeQuizChoosedSpecialistType,
    level: "",
    topic: "",
  });

  const directionData = {
    Coach: TreeQuizChoosedSpecialistType.COACH,
    Psychotherapist: TreeQuizChoosedSpecialistType.PSYCHOTHERAPIST,
  };

  useEffect(() => {
    if (!defaultSelectionData) return;
    setSelectionCombinations(
      defaultSelectionData.map((item) => ({
        direction: item.direction,
        language: item.language,
        level: {
          lable: getTranslation(item.level.title, "en"),
          value: item.level._id,
        },
        mainSpecialization: {
          lable: item.mainSpecialization.specialization,
          value: item.mainSpecialization._id,
        },
        topic: {
          lable: getTranslation(item.topic.labels, "en"),
          value: item.topic._id,
        },
      })),
    );
  }, [defaultSelectionData]);

  useEffect(() => {
    const selectionCombinationsToUpdate = selectionCombinations.map((item) => ({
      language: item.language,
      mainSpecialization: item.mainSpecialization.value,
      direction: item.direction as TreeQuizChoosedSpecialistType,
      level: item.level.value,
      topic: item.topic.value,
    }));
    if (
      lodash.isEqual(
        selectionCombinationsToUpdate,
        promocodeData.selectionCombinations,
      )
    )
      return;

    setPromocodeData((prev) => ({
      ...prev,
      selectionCombinations: selectionCombinationsToUpdate,
    }));
  }, [selectionCombinations]);

  const getSpecialiationLevels = async () => {
    if (!newSelectionCombination.mainSpecialization.length || !token) {
      setSelectFieldsData((prev) => ({ ...prev, levels: [] }));
    }
    const response = await SpecialistApi.getAllSpecialistLevels({
      mainSpecId: newSelectionCombination.mainSpecialization,
    });
    if (response.status && response.levels) {
      const levelsData = response.levels.map((item) => ({
        value: item._id,
        lable: getTranslation(item.title, "en"),
      }));
      setSelectFieldsData((prev) => ({ ...prev, levels: levelsData }));
    }
  };
  const getSpecialistTags = async () => {
    if (!newSelectionCombination.mainSpecialization.length || !token) {
      setSelectFieldsData((prev) => ({ ...prev, topic: [] }));
      return;
    }

    const selectedMainSpecTitle = selectFieldsData.mainSpecializations.find(
      (el) => el.value === newSelectionCombination.mainSpecialization,
    )?.lable;
    if (!selectedMainSpecTitle) return;
    const payload = {
      level: 1,
      direction: directions[selectedMainSpecTitle as keyof typeof directions],
    };
    const response = await SpecialistApi.getSpecialistTags(token, payload);
    if (response.status && response.tags) {
      setSelectFieldsData((prev) => ({
        ...prev,
        topic: response.tags!.map((item) => ({
          lable: item.title,
          value: item._id,
        })),
      }));
    }
  };
  useEffect(() => {
    getSpecialiationLevels();
    getSpecialistTags();
  }, [newSelectionCombination.mainSpecialization]);

  const removeSelectionItem = (index: number) => {
    setSelectionCombinations(
      selectionCombinations.filter((_, i) => i !== index),
    );
  };

  const addSelectionItem = () => {
    const { direction, mainSpecialization, language, level, topic } =
      newSelectionCombination;
    if (
      direction === ("" as TreeQuizChoosedSpecialistType) ||
      mainSpecialization === "" ||
      language === "" ||
      level === "" ||
      topic === ""
    ) {
      alert(
        `Please fill in all the fields required to add the "Selection" parameters`,
      );
      return;
    }

    const selectionToAdd = {
      language: language,
      mainSpecialization: {
        value: mainSpecialization,
        lable:
          selectFieldsData.mainSpecializations.find(
            (el) => el.value === mainSpecialization,
          )?.lable ?? "",
      },
      direction: direction,
      level: {
        value: level,
        lable:
          selectFieldsData.levels.find((el) => el.value === level)?.lable ?? "",
      },
      topic: {
        value: topic,
        lable:
          selectFieldsData.topic.find((el) => el.value === topic)?.lable ?? "",
      },
    };
    setSelectionCombinations((prev) => [...prev, selectionToAdd]);
    setNewSelectionCombination({
      language: "",
      mainSpecialization: "",
      direction: "" as TreeQuizChoosedSpecialistType,
      level: "",
      topic: "",
    });
  };

  return (
    <div>
      <div className={s.pricingContainer}>
        <MultipleSelect
          data={selectFieldsData.mainSpecializations}
          multiplie={false}
          setValue={(value) => {
            const selectedMainSpecTitle =
              selectFieldsData.mainSpecializations.find(
                (el) => el.value === value,
              )?.lable;
            setNewSelectionCombination((prev) => ({
              ...prev,
              mainSpecialization: value as string,
              direction:
                directionData[
                  selectedMainSpecTitle as keyof typeof directionData
                ],
            }));
          }}
          value={newSelectionCombination.mainSpecialization}
          width="20%"
          lable="Specialization"
        />
        <MultipleSelect
          data={selectFieldsData.languages}
          multiplie={false}
          setValue={(value) =>
            setNewSelectionCombination((prev) => ({
              ...prev,
              language: value as string,
            }))
          }
          value={newSelectionCombination.language}
          width="20%"
          lable="Language"
        />
        <MultipleSelect
          data={selectFieldsData.levels}
          multiplie={false}
          setValue={(value) =>
            setNewSelectionCombination((prev) => ({
              ...prev,
              level: value as string,
            }))
          }
          value={newSelectionCombination.level}
          width="20%"
          disabled={!selectFieldsData.levels.length ? true : false}
          lable="Level"
        />
        <MultipleSelect
          data={selectFieldsData.topic}
          multiplie={false}
          setValue={(value) =>
            setNewSelectionCombination((prev) => ({
              ...prev,
              topic: value as string,
            }))
          }
          value={newSelectionCombination.topic}
          width="20%"
          disabled={!selectFieldsData.topic.length ? true : false}
          lable="Topic"
        />
        <StandartButton
          action={addSelectionItem}
          buttonTitle="Add"
          width="20%"
        />
      </div>
      <table border={1} cellPadding={8} className={s.pricingTable}>
        <thead>
          <tr>
            <th>Language</th>
            <th>Specialization</th>
            <th>Level</th>
            <th>Topic</th>
          </tr>
        </thead>
        <tbody>
          {selectionCombinations.map((item, index) => (
            <tr key={index}>
              <td>{ISO639Lang[item.language] ?? " - "}</td>
              <td>{item.mainSpecialization.lable ?? " - "}</td>
              <td>{item.level.lable}</td>
              <td>{item.topic.lable}</td>
              <td>
                <button
                  className={s.removePriceBtn}
                  onClick={() => removeSelectionItem(index)}
                >
                  Remove
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PromocodeSelection;
